/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since  2018.3.15
 */
/**
 * 百度地图坐标系-baidu09
 * 这种接入方式不失为一种方式，但只局限亚非欧三个区域
 * @see 900913
 * @see 3857
 * @see 3395
 * @see https://github.com/luobotang/leaflet-baidu-tile-layer
 * @see https://github.com/muyao1987/leaflet-tileLayer-baidu
 * @see http://developer.baidu.com/map/custom/ 个性化底图制作
 */
L.CRS.Baidu09 = new L.Proj.CRS('EPSG:3857', '+proj=merc +a=6378206 +b=6356584.314245179 +lat_ts=0.0 +lon_0=0.0 +x_0=0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs', {
  resolutions: (() => {
    let res = [], i = 0;
    while (i < 19) {
      res[i] = Math.pow(2, 18 - i);
      i++;
    }
    return res;
  })(),
  origin: [0, 0],
  bounds: L.bounds([20037508.342789244, 0], [0, 20037508.342789244])
});


// import BaiduProj from './BaiduProj'

// L.CRS.Baidu09 = L.extend({}, L.CRS.Earth, {
//   code: 'EPSG:3857',

//   projection: BaiduProj,

//   wrapLng: undefined,

//   wrapLat: undefined,

//   R: 6370996.81,

//   scale: zoom => 256 * Math.pow(2, zoom),

//   zoom: scale => Math.log(scale / 256) / Math.LN2,

//   transformation: (() => {
//     const zoom = 18
//     const scale = 1 / (256 * Math.pow(2, zoom))
//     return new L.Transformation(scale, 0.5, -scale, 0.5)
//   })()
// })


// WEBPACK FOOTER //
// ./src/crs/Baidu09.js